import { render, staticRenderFns } from "./wifiBox.vue?vue&type=template&id=e8104808&scoped=true"
import script from "./wifiBox.vue?vue&type=script&lang=js"
export * from "./wifiBox.vue?vue&type=script&lang=js"
import style0 from "./wifiBox.vue?vue&type=style&index=0&id=e8104808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8104808",
  null
  
)

export default component.exports